var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.users),function(user,idx){return _c('span',{key:user.id},[_c('user',{attrs:{"user":user}}),_vm._v(" "+_vm._s(_vm.users.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }